export default __webpack_public_path__ + "alberta-wound-permanent.4382450714dca5554881.svg";